module.exports = __webpack_public_path__ + "img/brands-mulino-page-header.jpg?c2668a765539e880ac185ec99d6cc91d";